import { FormGroup } from '@angular/forms';

export function PatentValidator(patent: string) {
	return (formGroup: FormGroup) => {
		const control = formGroup.controls[patent];

		if (control.errors && !control.errors.patent) {
			// return if another validator has already found an error on the matchingControl
			return;
		}
		const value = control.value.replace(/\W+/g, '').toUpperCase();

		if (value.length < 5) {
			control.setErrors({ patent: true });
		} else if (value.length === 5) {
			if (
				!value.match(/^[a-z]{2}0[0-9]{3}$|^[a-z]{2}[0-9]{3}$/i) &&
				!value.match(/^[b-d,f-h,j-l,p,r-t,v-z]{3}[0-9]{2}$|^[b-d,f-h,j-l,p,r-t,v-z]{3}0[0-9]{2}$/i)) {
				control.setErrors({ patent: true });
			}
		} else if (value.length === 6) {
			if (
				!value.match(/^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}$/i) &&
				!value.match(/^[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}$/i)) {
				control.setErrors({ patent: true });
			}
		} else if (control.value.length === 7) {
			control.setErrors({ patent: true });
		} else {
			control.setErrors(null);
		}
	}
}
